<template>
  <a-modal
    title="入库数据推送金蝶"
    :width="980"
    :visible="visible"
    :confirmLoading="loading"
    @ok="() => { $emit('ok') }"
    @cancel="() => { $emit('cancel') }"
  >
    <template slot="footer">
      <a-button key="back" @click="() => { $emit('cancel') }">
        取消
      </a-button>
      <a-button key="submit" type="primary" :loading="loading" @click="() => { $emit('ok') }">
        推送
      </a-button>
    </template>
    <a-spin :spinning="loading">
      <a-form :form="form">
        <a-row>
          <a-col :span="24">
            <a-divider orientation="left">
              关联信息
            </a-divider>
          </a-col>
          <a-col :span="12" v-if="true">
            <a-form-item label="采销全流程" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <span>{{ this.model.project || '' }}</span>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="sellContractLabel" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <span>{{ this.model.sell_contract || '' }}</span>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="this.model.project_id > 0 && model['type'] !== 3">
            <a-form-item :label="totalCountLabel" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <span style="padding-left: 10px" v-if="model['type'] === 1">{{ total_count }}</span>
              <span style="padding-left: 10px" v-if="model['type'] === 2">{{ remaining_total_count }}</span>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-divider orientation="left">
              {{ model['type'] === 1 ? '入库信息' : '出库信息' }}
            </a-divider>
          </a-col>
          <a-col :span="12">
            <a-form-item label="编号" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <span>{{ this.model.number || '' }}</span>
            </a-form-item>
          </a-col>
          <a-col :span="12" :layout="formLayout">
            <a-form-item label="仓库" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <span>{{ this.model.warehouse || '' }}</span>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="model['type'] === 2">
            <a-form-item label="货转模式" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <span>{{ this.freightTransferModeList[this.model.goods_transfer_mode] || '' }}</span>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="model['type'] === 3">
            <a-form-item label="耗损类型" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <span>{{ this.depletionTypeList[this.model.loss_type] || '' }}</span>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="提货单毛量" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <span>{{ this.model.gross_weight || '' }}</span>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="提货单净量" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <span>{{ this.model.net_weight || '' }}</span>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="过磅量" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <span>{{ this.model.weighing_capacity || '' }}</span>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="model['type'] !== 3">
            <a-form-item label="单位" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <span>{{ this.unit[this.model.unit] || '' }}</span>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="model['type'] !== 3">
            <a-form-item label="单价" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <span>{{ this.model.unit_price || '' }}</span>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="model['type'] !== 3">
            <a-form-item label="货币" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <span>{{ this.currency[this.model.currency] || '' }}</span>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="model['type'] !== 3">
            <a-form-item label="预估人民币单价" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <span>{{ this.model.unit_price_cny || '' }}</span>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="false">
            <a-form-item label="备注" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <span>{{ this.model.remark || '' }}</span>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="inOutDateLabel" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <span>{{ this.model.in_out_date || '' }}</span>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-divider orientation="left">
              补充信息
            </a-divider>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="model['type'] === 1 ? '暂定数量' : '暂定数量'" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input-number :precision="4" style="width: 50%" v-decorator="['real_weight', {rules: [{required: true, message: '必填项，请填写信息'}]}]" :placeholder="model['type'] === 1 ? '实收数量' : '实发数量'"/>
              <a-tooltip :title="(model['type'] === 1 ? '暂定数量' : '暂定数量') + '：外贸业务为报关单数量；内贸业务为进项发票取得数量。此数量对应金蝶系统中采购入库单的应收数量。'">
                <a-icon type="info-circle" theme="filled" style="padding-left: 8px"/>
              </a-tooltip>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="model['type'] === 1">
            <a-form-item label="报关日期" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-date-picker
                v-decorator="['declaration_date', {rules: [{required: true, message: '必填项，请填写信息'}]}]"
                format="YYYY-MM-DD"
                value-format="yyyy-MM-DD"
              />
              <a-tooltip title="报关日期：外贸业务为报关单申报日期；内贸业务为进项发票取得日期。此日期推送到金蝶系统中使用。">
                <a-icon type="info-circle" theme="filled" style="padding-left: 8px"/>
              </a-tooltip>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import pick from 'lodash.pick'
import { inventory_total } from '@/api/trade_inventory'

// 表单字段
const fields = ['real_weight', 'declaration_date']
export default {
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: () => false
    },
    model: {
      type: Object,
      default: () => null
    }
  },
  data () {
    this.formLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 13 }
      }
    }
    return {
      formLayout: 'horizontal',
      total_count: 0,
      remaining_total_count: 0,
      depletionTypeList: this.$Dictionaries.trade_inventory_loss_type,
      freightTransferModeList: this.$Dictionaries.trade_inventory_goods_transfer_mode,
      unit: this.$Dictionaries.unit,
      currency: this.$Dictionaries.currency,
      form: this.$form.createForm(this)
    }
  },
  created () {
    console.log('show', this.model)
    // 防止表单未注册
    fields.forEach(v => this.form.getFieldDecorator(v))
    // 当 model 发生改变时，为表单设置值
    this.$watch('model', () => {
      this.model && this.form.setFieldsValue(pick(this.model, fields))
    })
    this.model && this.form.setFieldsValue(pick(this.model, fields))
  },
  mounted () {
    this.inventoryTotal()
  },
  methods: {
    inventoryTotal () {
      const param = { project_id: this.model.project_id, trade_type: this.model['type'] }
      console.log('inventoryTotal', param)
      inventory_total(param).then(res => {
        if (res.code === 1000) {
          if (this.model['type'] === 1) {
            this.total_count = res.data
          } else if (this.model['type'] === 2) {
            this.remaining_total_count = res.data
          }
        }
      })
    }
  },
  computed: {
    title () {
      if (this.model['type'] === 1) {
        return '新建入库'
      } else if (this.model['type'] === 2) {
        return '新建出库'
      } else {
        return '新建平账'
      }
    },
    inOutDateLabel () {
      if (this.model['type'] === 1) {
        return '入库时间'
      } else if (this.model['type'] === 2) {
        return '出库时间'
      } else {
        return '出库时间'
      }
    },
    sellContractLabel () {
      if (this.model['type'] === 1) {
        return '采购合同编号'
      } else if (this.model['type'] === 2) {
        return '销售合同编号'
      } else {
        return '销售合同编号'
      }
    },
    totalCountLabel () {
      if (this.model['type'] === 1) {
        return '总入库量'
      } else if (this.model['type'] === 2) {
        return '剩余库量'
      } else {
        return ''
      }
    },
    formItemLayout () {
      const { formLayout } = this
      return formLayout === 'horizontal'
        ? {
          labelCol: { span: 6 },
          wrapperCol: { span: 18 }
        } : {}
    },
    buttonItemLayout () {
      const { formLayout } = this
      return formLayout === 'horizontal'
        ? {
          labelCol: { span: 3 },
          wrapperCol: { span: 21 }
        } : {}
    }
  }
}
</script>
